import formatDecimal from "./formatDecimal.js";

export default function(x) {
  return x = formatDecimal(Math.abs(x)), x ? x[1] : NaN;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-scale/node_modules/d3-format/src/exponent.js
// module id = 75
// module chunks = 0